import { render, staticRenderFns } from "./actionListTableComponent.vue?vue&type=template&id=47a6af9c"
import script from "./actionListTableComponent.vue?vue&type=script&lang=js"
export * from "./actionListTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports